"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rating = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm/browser");
const rating_contact_type_1 = require("./rating-contact-type");
const rating_detail_1 = require("./rating-detail");
let Rating = class Rating {
};
__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], Rating.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({
        unique: true,
    }),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Generated)('uuid'),
    __metadata("design:type", String)
], Rating.prototype, "uuid", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        name: 'job_id',
        length: 18,
    }),
    __metadata("design:type", String)
], Rating.prototype, "jobId", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: rating_contact_type_1.RatingContactType,
        default: rating_contact_type_1.RatingContactType.PARTNER,
        name: 'contact_type',
    }),
    __metadata("design:type", String)
], Rating.prototype, "contactType", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        name: 'contact_id',
        length: 18,
    }),
    __metadata("design:type", String)
], Rating.prototype, "contactId", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        name: 'opportunity_id',
        length: 18,
    }),
    __metadata("design:type", String)
], Rating.prototype, "opportunityId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, typeorm_1.Column)('text', {
        nullable: true,
        name: 'comment',
    }),
    __metadata("design:type", String)
], Rating.prototype, "comment", void 0);
__decorate([
    (0, typeorm_1.Column)('float', {
        default: 0,
        name: 'value',
    }),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(5),
    __metadata("design:type", Number)
], Rating.prototype, "value", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.Column)('boolean', {
        default: false,
        name: 'finished',
    }),
    __metadata("design:type", Boolean)
], Rating.prototype, "finished", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
        name: 'created_at',
    }),
    __metadata("design:type", Date)
], Rating.prototype, "createdAt", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
        name: 'updated_at',
    }),
    __metadata("design:type", Date)
], Rating.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => rating_detail_1.RatingDetail, (item) => item.rating, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], Rating.prototype, "items", void 0);
Rating = __decorate([
    (0, typeorm_1.Entity)('rating', { schema: 'rating' }),
    (0, typeorm_1.Unique)(['jobId', 'contactId', 'contactType'])
], Rating);
exports.Rating = Rating;
//# sourceMappingURL=rating.js.map